// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "SwapConfirmationModal_modalContainer__ybD6k";
var _3 = "SwapConfirmationModal_modalOverlay__srp8g";
var _4 = "SwapConfirmationModal_modalWrapper__-NV-g";
var _5 = "'../../shared.module.css'";
export { _1 as "md", _2 as "modalContainer", _3 as "modalOverlay", _4 as "modalWrapper", _5 as "shared" }
